import { createRoute, redirect } from '@tanstack/react-router';

import { hasPermissionFactory } from '$/components/core/Authentication/hooks/useAuthorization';
import { useAuthenticationStore } from '$/components/core/Authentication/stores/useAuthenticationStore';
import { SchoolClassPage } from '$/pages/SchoolClassPage';
import { BaseRouteLayout } from '$/routes/Layouts/BaseRouteLayout';

export const SchoolClassRoute = createRoute({
  getParentRoute: () => BaseRouteLayout,
  path: '/classes/$id',
  component: SchoolClassPage,
  beforeLoad: () => {
    const { user } = useAuthenticationStore.getState();

    if (!hasPermissionFactory(user?.role ?? 'free')('School_See_Classes')) {
      redirect({ to: '/not-allowed', throw: true });
    }
  },
});
